module.exports = __webpack_public_path__ + "img/uspto_logo.fd88dde4.png";